var layoutPadding = 220;
var seatWidth = 36;
var seatHeight = 36;
var seatPadding = 8;
var exitSeatWidth = 18;
var leftWingIntersectionEndCoordinate = 50;
var normalMapSizeThreshold = 10;
var getSeatGridItemDimension = function (itemDimension, itemPadding) {
    return itemDimension + itemPadding;
};
var getTotalSeatItemDimension = function (itemCount, itemTotalPadding) { return itemCount * itemTotalPadding; };
var getCabinWidth = function (seatCount, exitsCount, aislesCount) {
    var widthPadding = getSeatGridItemDimension(seatWidth, seatPadding);
    var exitSeatPadding = getSeatGridItemDimension(exitSeatWidth, seatPadding);
    return (getTotalSeatItemDimension(seatCount, widthPadding) +
        getTotalSeatItemDimension(exitsCount, exitSeatPadding) +
        getTotalSeatItemDimension(aislesCount, widthPadding) +
        seatPadding);
};
var getTotalWidth = function (cabinWidth) { return cabinWidth + layoutPadding * 2; };
var getTotalHeight = function (rowCount, heightPadding) {
    return getTotalSeatItemDimension(rowCount, heightPadding) + seatPadding;
};

export { exitSeatWidth, getCabinWidth, getSeatGridItemDimension, getTotalHeight, getTotalWidth, layoutPadding, leftWingIntersectionEndCoordinate, normalMapSizeThreshold, seatHeight, seatPadding, seatWidth };
